import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, unref as _unref, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = ["id"]
const _hoisted_3 = ["aria-label"]

import { ref, onUpdated, onMounted, watch } from 'vue';
import { usePremCalcStore } from "@premcalc/store/premCalcStore";


export default /*#__PURE__*/_defineComponent({
  __name: 'Modal',
  props: {
  // If we don't want a link to trigger the showing of the modal
  show: Boolean,
  id: String,
},
  emits: ["closeModal", "showModal"],
  setup(__props, { emit: __emit }) {

const store = usePremCalcStore();

const props = __props;

const emit = __emit

const dialog = ref<HTMLDialogElement>();
const showModal = ref(false);

watch(() => store.showModal, () => {
  if (store.showModal) {
    onShowModal();
  } else {
    onCloseModal();
  }
});

const onShowModal = () => {
  showModal.value = true;
  document.body.classList.add('disable-scroll');

  emit('showModal'); // In case someone wants to listen ¯\_(ツ)_/¯
};

const onCloseModal = () => {
  showModal.value = false;
  document.body.classList.remove('disable-scroll');
  window.removeEventListener('resize', onResize);

  emit('closeModal'); // In case someone wants to listen ¯\_(ツ)_/¯
}

onMounted(() => {
  if (props.show) {
    onShowModal();
  }

  closeModalOnBackdropClickListener();
});

onUpdated(() => {
  // Delay so modal is completely rendered and we'll get an accurate height
  setTimeout(() => {
    setScrollStyle();
  }, 300);
});

// Listens to clicks outside the modal, and closes it
const closeModalOnBackdropClickListener = () => {
  dialog.value?.addEventListener('click', ((event) => {
    let rect = (event?.target as HTMLElement)?.getBoundingClientRect();

    if (rect.left > event.clientX ||
      rect.right < event.clientX ||
      rect.top > event.clientY ||
      rect.bottom < event.clientY) {
      onCloseModal();
    }
  }));
}

function onResize() {
  setTimeout(() => {
    setScrollStyle();
  }, 200);
}

// Checks if dialog is taller than the screen, and if so, adds a class to it that enables vertical scroll
function setScrollStyle() {
  if (!dialog.value) {
    return;
  }

  const children = dialog.value.children;
  let modalHeight = 0;

  if (children instanceof HTMLCollection) {
    modalHeight = Array.from(children).reduce((sum, child) => {
      return sum + (child as HTMLLIElement).offsetHeight
    }, 0);
  } else {
    modalHeight = dialog.value.offsetHeight;
  }

  if (modalHeight > window.innerHeight) {
    // Modal is taller than window, add scroll
    dialog.value.classList.add('modal--scroll');
  } else {
    dialog.value.classList.remove('modal--scroll');
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _renderSlot(_ctx.$slots, "link", { clicked: onShowModal }),
    (showModal.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("section", {
            ref_key: "dialog",
            ref: dialog,
            id: __props.id,
            class: "modal modal--narrow",
            "aria-modal": "true"
          }, [
            _createElementVNode("button", {
              class: "modal__close icon icon--close",
              onClick: _withModifiers(onCloseModal, ["prevent"]),
              "aria-label": _unref(store).translations?.ariaClose
            }, _toDisplayString(_unref(store).translations?.ariaClose), 9 /* TEXT, PROPS */, _hoisted_3),
            _renderSlot(_ctx.$slots, "content", { close: onCloseModal })
          ], 8 /* PROPS */, _hoisted_2),
          _createElementVNode("div", {
            class: "modal-backdrop",
            onClick: onCloseModal
          })
        ]))
      : _createCommentVNode("v-if", true)
  ], 64 /* STABLE_FRAGMENT */))
}
}

})